import React, { Component } from 'react';
import TextInput from '../../../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../../../utils/commonUtil';
const errorObject = require('../../../../../../../utils/errors/LP_GR_error.json');
class PersonalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: props.personalData?.title || '',
            PersonalFormdata: props.personalData || {},
            initialFormdata: props.personalData || {},
            disableSubmit: true,
            initialPersonaPhone: props.personalData.phone,
        };
    }
    isValueAvailable = (str) => {
        if (str && str.trim()) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.setState({
            title: this.props.personalData?.title || '',
            PersonalFormdata: this.props.personalData,
            initialFormdata: this.props.personalData,
            initialPersonaPhone: this.props.personalData?.phone || '',
            enableCheckBox: this.props.personalData?.hasPermission || false
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.personalData !== this.props.personalData) {
            this.setState({
                title: this.props.personalData?.title || '',
                PersonalFormdata: this.props.personalData,
                initialFormdata: this.props.personalData,
                initialPersonaPhone: this.props.personalData?.phone || '',
                enableCheckBox: this.props.personalData?.hasPermission || false
            });
        }
    }

    onchangePersonalHandler = (e) => {
        const { initialPersonaPhone } = this.state
        const { name, value } = e.target;
        this.setState((prevState) => ({
            PersonalFormdata: {
                ...prevState.PersonalFormdata, // Spread previous formData
                [name]: value, // Update only the specific field
            }
        }), () => {
            if (name == 'phone' && initialPersonaPhone != value && value.length > 0) {
                this.disableSubmitButton(false)

            }
            else {
                this.disableSubmitButton(true)

            }
        });
    }

    disableSubmitButton = (val) => {
        this.setState({
            disableSubmit: val
        })
    }


    validate = () => {
        const { PersonalFormdata } = this.state;
        const phoneNumber = PersonalFormdata.phone
        let phoneNumberValid = true;
        //phone number validation
        if (phoneNumber) {
            const phoneNumberValidationRules = [
                { functionRef: this.isValueAvailable, funcData: [phoneNumber], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.required.field') },
                { functionRef: commonUtil.validateNumber, funcData: [phoneNumber], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.invalid.field') },
            ];
            phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.phone, null);
            if (!phoneNumberValid) {
                return false
            }
        }

        this.SubmitPeronalInfo();
        // this.resetPersonalForm();
        
    }

    SubmitPeronalInfo() {
        const { PersonalFormdata } = this.state;
        const payload = {
            "ownerId": PersonalFormdata.repositoryId,
            "ownerTitle": PersonalFormdata.title,
            "ownerHasPermission": PersonalFormdata.hasPermission,
            "ownerfirstName": PersonalFormdata.firstName,
            "ownerlastName": PersonalFormdata.lastName,
            "ownerMotherName": PersonalFormdata.motherName,
            "ownerPhone": PersonalFormdata.phone,
            "ownerEmail": PersonalFormdata.email
        }

        this.props.updateOwnerDetails(payload);
        this.disableSubmitButton(true);
    }

    resetPersonalForm = () => {
        this.setState({
            PersonalFormdata: this.state.initialFormdata,
            disableSubmit: true,
        }, () => {
            const { PersonalFormdata } = this.state;
            const phoneNumber = PersonalFormdata.phone
            let phoneNumberValid = true;
            //phone number validation
            if (phoneNumber) {
                const phoneNumberValidationRules = [
                    { functionRef: this.isValueAvailable, funcData: [phoneNumber], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.required.field') },
                    { functionRef: commonUtil.validateNumber, funcData: [phoneNumber], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.invalid.field') },
                ];
                phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.phone, null);
                if (!phoneNumberValid) {
                    return false
                }
            }
        })
    }

    render() {
        const { personalData, firstNameRef } = this.props;

        const { PersonalFormdata ,title} = this.state;

        let actualizarDatos = {
            id: 'updateData',
            type: 'button',
            name: 'Guardar cambios',
            value: 'Guardar cambios',
            classname: 'personal-data-button',
            onClickHandler: () => {
                // Handle clear filter action
                this.validate()
            },
            disabled: this.state.disableSubmit,
            autoFocus: false,
            ariaLabel: 'update personal data',
            ariaHidden: false,
            cssStyle : !this.state.disableSubmit ? {backgroundColor : this.props.selectedTheme?.color_500,color : "#fff"} : ""
        };

        let cancelButton = {
            className: 'personal-data-cancel-button',
            name: 'Cancelar',
            type: 'button',
            value: 'Cancelar',
            disabled: this.state.disableSubmit,
            autoFocus: false,
            style: 'personal-data-cancel-button',
            onClickHandler: () => {
                this.resetPersonalForm();
            },
            cssStyle : !this.state.disableSubmit ? { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 } : ""
        };

        return (
            <>
                {PersonalFormdata &&
                    <form>
                        <div className='personal-data-your-section'>
                            <div className='required-field-lable'>
                                *Campos obligatorios
                            </div>

                            <div className='personal-data-title'>
                                Tus datos <span style={{
                                    fontWeight: 'lighter'
                                }}>(Administrador)</span>
                            </div>
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="firstName"
                                label="Nombre"
                                name="firstName"
                                required="true"
                                star="*"
                                value={PersonalFormdata.firstName || ''}
                                // onChange={(e) => {this.props.onchangePersonalHandler(e) }}
                                disabled={true}
                            />

                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="lastName"
                                label="Primer apellido"
                                name="lastName"
                                required="true"
                                star="*"
                                value={PersonalFormdata.lastName || ''}
                                // onChange={(e) => {this.props.onchangePersonalHandler(e) }}
                                disabled={true}
                            />
                            <TextInput
                                className={`inputMaterial ${PersonalFormdata?.motherName ? '' : 'lastnameInput'}`}
                                labelClassName="placeHolderMaterial"
                                htmlId="motherName"
                                label="Segundo apellido"
                                name="motherName"                                 
                                value={PersonalFormdata.motherName || ''}
                                // onChange={(e) => {this.props.onchangePersonalHandler(e) }}
                                disabled={true}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="Personalphone"
                                name="phone"
                                label="Celular"
                                required="true"
                                star="*"
                                maxlength="10"
                                value={PersonalFormdata.phone || ''}
                                onChange={(e) => { this.onchangePersonalHandler(e) }}
                                ref={el => (this.phone = el)}
                                onKeyDown={(e) => { commonUtil.handleAllowOnlyDigit(e); }}
                                disabled={true}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="email"
                                label="Correo electrónico"                                 
                                maxlength="100"
                                required="true"
                                star="*"
                                name="email"
                                parentClassName={''}
                                disabled={true}
                                value={PersonalFormdata.email || ''}
                            />


                            {/* <div className="personal-data-button-wrapper">
                                <InputButton buttonAttr={cancelButton} />
                                <InputButton buttonAttr={actualizarDatos} />                                 
                            </div> */}

                        </div>
                    </form>
                }
            </>
        );
    }
}

export default PersonalForm;